import React from 'react';
import moment from 'moment';
import { message } from 'antd';
import _, { cloneDeep } from 'lodash';
import pick from 'lodash/pick';
import omit from 'lodash/omit';
import get from 'lodash/get';
import {
  getList,
  addGroup,
  updateGroup,
  addResourceToGroup,
  addUserToGroup,
  addRoleToGroup,
  getUsersInGroup,
  getUserInGroup,
  removeUserGroup,
  getRolesInGroup,
  removeRoleInGroup
} from '../services/group';
import session from '../utils/session';

const RESOURCE = 'groups';
const transfromDocument = (record) => {
  if (record.created) {
    const createdAt = record.created;
    record.created = moment.unix(createdAt);
  }
  if (record.updatedAt) {
    const updatedAt = record.updatedAt;
    record.updatedAt = moment.unix(updatedAt);
  }

  return record;
};

export default {
  namespace: 'group',

  state: {
    data: {
      list: [],
      pagination: {
        anchor: '',
        listAnchor: {
          1: ''
        }
      },
    },
    submitting: false,
    formTitle: '',
    formID: '',
    formVisible: false,
    formData: {},
  },

  effects: {
    *fetch({ payload, callback }, { call, put }) {
      let list = [];
      try {
        const response = yield call(getList, payload);
        if (response) {
          if (response.groups) {
            list = response.groups.map(item => {
              transfromDocument(item);
              return item;
            });
          }
          yield put({
            type: 'save',
            payload: {
              list,
              pagination: {
                total: response.total,
                anchor: get(response, ["anchor"], ""),
                listAnchor: {
                  [((payload && payload.current) || 1) + 1]: get(response, ["anchor"], "")
                }
              }
            },
          });
        }
      } catch (error) {
        console.log('*fetch -> error', error);
      }
      if (callback) {
        callback(list);
      }
    },
    *loadForm({ payload }, { put, all }) {
      console.log('*loadForm -> payload', payload);
      if (payload.type !== 'RESET') {
        yield put({
          type: 'changeFormVisible',
          payload: true,
        });
      }

      yield [
        put({
          type: 'saveFormType',
          payload: payload.type,
        }),
        put({
          type: 'saveFormTitle',
          payload: 'Tạo mới nhóm quyền',
        }),
        put({
          type: 'saveFormID',
          payload: '',
        }),
        put({
          type: 'saveFormData',
          payload: {},
        }),
      ];

      if (payload.type === 'E') {
        let menus = [];
        let roles = [];
        if (payload.item && payload.item.menus) {
          for (let menu of payload.item.menus) {
            console.log('*loadForm -> menu', menu);
            try {
              const newMenu = JSON.parse(menu);
              if (newMenu) {
                menus.push(Object.keys(newMenu)[0]);
                roles.push(Object.values(newMenu)[0]);
              }
            } catch (error) {

            }
          }
        }
        yield [
          put({
            type: 'saveFormTitle',
            payload: 'Chỉnh sửa nhóm quyền',
          }),
          put({
            type: 'saveFormID',
            payload: payload.id,
          }),
          put({
            type: 'saveFormData',
            payload: {
              ...payload.item,
              roles: {
                data: roles
              },
              menus
            },
          }),
        ];
      }
      else if (payload.type === 'USER_TO_GROUP') {
        yield all([
          put({
            type: 'saveFormTitle',
            payload: 'Thêm người dùng vào nhóm quyền',
          }),
          put({
            type: 'saveFormID',
            payload: payload.id,
          }),
          put({
            type: 'fetchUserInGroup',
            payload: payload.item,
          }),
        ]);
      }
      else if (payload.type === 'ROLE_TO_GROUP') {
        yield [
          put({
            type: 'saveFormTitle',
            payload: 'Thêm quyền',
          }),
          put({
            type: 'saveFormID',
            payload: payload.id,
          }),
          put({
            type: 'fetchRolesInGroup',
            payload: payload.item,
          }),
        ];
      }
    },
    *fetchUserInGroup({ payload }, { call, put }) {
      const response = yield call(getUsersInGroup, { group_id: payload.group_id });

      yield put({
        type: 'saveFormData',
        payload: {
          ...payload,
          user_ids: (response && response.user_ids) || []
        },
      });
    },
    *fetchRolesInGroup({ payload }, { call, put }) {
      const response = yield call(getRolesInGroup, { group_id: payload.group_id });
      console.log('*fetchRolesInGroup -> response', response);

      yield put({
        type: 'saveFormData',
        payload: {
          ...payload,
          partner_ids: (
            response
            && response.roles
            && response.roles.map(i => ({
              resource: i.split('$$')[1],
              partner_id: i.split('$$')[2]
            }))) || []
        },
      });
    },
    *submit({ payload }, effects) {
      const { all, call, put, select } = effects;
      yield put({
        type: 'changeSubmitting',
        payload: true,
      });

      let params = { ...payload };
      const formType = yield select(state => state.group.formType);
      console.log('*submit -> formType', formType);
      const formID = yield select(state => state.group.formID);

      let success = false;
      let userExistGroup = [];
      let usersToGroup = [];
      switch (formType) {
        case 'E':
          const newParams = cloneDeep(params);
          console.log('*submit -> newParams', newParams);
          try {
            params.group_id = formID;
            let menus = [];
            if (newParams.menus && newParams.menus.length > 0) {
              const keyMenus = newParams.menus.map(i => i.key);
              // console.log('*submit -> keyMenus', keyMenus);
              for (let keyMenu of keyMenus) {
                // console.log('*submit -> keyMenu', keyMenu);
                if (newParams.roles.data && newParams.roles.data.length > 0) {
                  menus.push(JSON.stringify({ [keyMenu]: newParams.roles.data.find(i => i.id == keyMenu) }));
                } else if (newParams.roles && newParams.roles.length > 0) {
                  menus.push(JSON.stringify({ [keyMenu]: newParams.roles.find(i => i.id == keyMenu) }));
                }
              }
              // session.set('menus', menus);
              params.menus = menus;
            }

            delete params.name;
            delete params.roles;
            console.log('E *submit -> params', params);

            const response = yield call(updateGroup, params);
            if (response && response.group_id !== null && response.group_id !== '') {
              success = true;
            }
          } catch (error) {
            console.log(`🚀 ~ file: group.js ~ line 271 ~ error`, error);
            success = false;
          }
          break;
        case 'USER_TO_GROUP':
          try {
            const resUserExist = yield all(
              (payload.user_ids || []).map(uId => call(getUserInGroup, uId))
            );
            console.log('*submit -> resUserExist', resUserExist);
            if (resUserExist) {
              userExistGroup = _.filter(resUserExist, (u) => u.group && u.group.group_id !== null && u.group.group_id !== '') || [];
              usersToGroup = _.filter(resUserExist, (u) => !u.group);

              console.log('*submit -> userExistGroup %o \n usersToGroup %o', userExistGroup, usersToGroup);
              yield all(
                (usersToGroup || [])
                  .map(u => u.user_id)
                  .map(uId => call(addUserToGroup, { user_id: uId, group_id: formID }))
              );
            }
            yield all(
              (payload.in_user_ids || []).map(uId => call(removeUserGroup, { user_id: uId, group_id: formID }))
            );
            success = true;
          } catch (error) {
            console.log('*submit -> error', error);
            success = false;
          }
          break;
        case 'ROLE_TO_GROUP':
          if (params.resource) {
            params.resource = params.resource.key;
          }
          if (params.not_partner_ids && params.not_partner_ids.length > 0) {
            yield call(addRoleToGroup, {
              resource: params.resource,
              partner_ids: params.not_partner_ids,
              group_id: formID
            });
          } else if (params.in_partner_ids && params.in_partner_ids.length > 0) {
            yield call(removeRoleInGroup, {
              resource: params.resource,
              partner_ids: params.in_partner_ids,
              group_id: formID
            });
          }
          success = true;
          break;
        case 'A':
          try {
            console.log('*submit -> params', params);
            const newParams = _.cloneDeep(params);
            const resAddGroup = yield call(addGroup, { name: newParams.name, partner_id: newParams.partner_id.id });
            console.log('*submit -> resAddGroup', resAddGroup);
            delete params.partner_id;
            delete params.name;
            if (params.menus) {
              const keyMenus = params.menus.map(i => i.key);
              let menus = keyMenus.map(i => (JSON.stringify({
                [i]: {
                  ...(params.roles || []).find(j => j.id === i)
                }
              })));
              params.menus = menus;
              delete params.roles;
            }
            if (resAddGroup && resAddGroup.group_id !== 0 && resAddGroup.group_id !== null) {
              params.group_id = resAddGroup.group_id;
              yield call(addResourceToGroup, params);
            }
            success = true;
          } catch (error) {
            console.log('*submit -> formType %o-> error %o', formType, error);
            success = false;
          }
          break;
        default:
          success = false;
          break;
      }

      yield put({
        type: 'changeSubmitting',
        payload: false,
      });

      if (success) {
        if (formType === 'USER_TO_GROUP' && userExistGroup.length > 0) {
          message.warning({
            content: (<div>
              <p>{usersToGroup.length} quyền được thêm.</p>
              <p>Người dùng {(userExistGroup || []).map(u => u.user_id).join(',')} trong nhóm quyền khác.</p>
            </div>),
            duration: 10
          });
        } else {
          message.success('Thành công');
        }

        yield put({
          type: 'changeFormVisible',
          payload: false,
        });
        yield put({
          type: 'fetch',
        });

      }
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        data: {
          ...state.data,
          list: action.payload.list,
          pagination: {
            ...state.data.pagination,
            anchor: action.payload.pagination.anchor,
            total: action.payload.pagination.total,
            listAnchor: {
              ...action.payload.pagination.listAnchor,
              ...state.data.pagination.listAnchor,
            }
          },
        },
      };
    },
    changeFormVisible(state, { payload }) {
      return { ...state, formVisible: payload };
    },
    saveFormTitle(state, { payload }) {
      return { ...state, formTitle: payload };
    },
    saveFormType(state, { payload }) {
      return { ...state, formType: payload };
    },
    saveFormID(state, { payload }) {
      return { ...state, formID: payload };
    },
    saveFormData(state, { payload }) {
      return { ...state, formData: payload };
    },
    changeSubmitting(state, { payload }) {
      return { ...state, submitting: payload };
    },
  },
};
